import { render, staticRenderFns } from "./SearchSort.vue?vue&type=template&id=572b8102&"
import script from "./SearchSort.vue?vue&type=script&lang=js&"
export * from "./SearchSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports